export default "__VITE_ASSET__CUJTVng0__"